<main id="main-content" class="main-content" *ngIf="report()">
  <h2 class="form-header">5. Assessment Cost </h2>

  <mat-card>
    <div class="subtitle" style="font-weight: 700;">Assessment Cost</div>
    <p style="color: #727272; margin-left: 5px; margin-top: 10px; font-size: 16px;">This cost includes all forests in
      the report, and is
      <span style="font-weight: 700;">not included</span> in the Total Requested amount.
    </p>
    <p style="margin-top: 10px;">{{(report().assessment_cost | currency) ?? '--'}}</p>
  </mat-card>
</main>